<template>
	<van-popup
		v-model="showPopup"
		:close-on-click-overlay="!requestLoading"
		position="bottom"
		safe-area-inset-bottom
		@close="closePopup()"
	>
		<div v-if="loading" class="loading-calender">
			<div class="van-loading van-loading--circular van-loading--vertical">
				<span class="van-loading__spinner van-loading__spinner--circular">
					<img src="../assets/images/investor_appointment/loading.png" />
				</span>
				<span class="loading-text">{{ $t('加载中') }}...</span>
			</div>
		</div>
		<div v-else-if="dateList.length == 0" class="empty-calendar">
			<m-empty></m-empty>
		</div>
		<div v-else class="appointment-calendar-popup">
			<div class="header">
				<span>{{ selectedTime ? `${$t('预约')} ${selectedTimeStr}` : $t('选择预约开始时间') }}</span>
				<span class="confirm-button" :class="{ 'enable-btn': selectedTime }" @click="confirm()">
					{{ $t('确定') }}
				</span>
			</div>
			<div class="main">
				<div class="months">
					<van-tabs
						v-model="activeMonth"
						:ellipsis="false"
						:color="getIrThemeColor"
						line-width="20"
						line-height="2"
						@change="changeTab"
					>
						<van-tab v-for="item in dateList" :title="item.label" :key="item.month"></van-tab>
					</van-tabs>
				</div>
				<div class="date-time">
					<div class="date-container">
						<div
							:id="'date-' + item.value"
							class="date-item"
							:class="{ 'date-item-active': item.value == activeDay }"
							v-for="item in activeDateList"
							:key="item.value"
							@click="getOptionalTime(item.value)"
						>
							{{ item.label }}
						</div>
					</div>
					<div class="time-container">
						<div
							:id="'time-' + item.time"
							class="time-item"
							:class="{
								'time-item-disabled': !item.isOptional,
								'time-item-active': item.time == selectedTime
							}"
							v-for="item in timeList"
							:key="item.time"
							@click="selectTime(item)"
						>
							{{ item.timeStr }}
						</div>
					</div>
				</div>

				<div v-if="requestLoading" class="request-loading">
					<div class="van-loading van-loading--circular van-loading--vertical">
						<span class="van-loading__spinner van-loading__spinner--circular">
							<img src="../assets/images/investor_appointment/loading.png" />
						</span>
						<span class="loading-text">加载中...</span>
					</div>
				</div>
			</div>
		</div>
	</van-popup>
</template>

<script>
import { Popup, Tab, Tabs } from 'vant';
import { appointment, irstore } from '@/fetch/interface';
import { EN } from '@/assets/js/i18n';
import { mapGetters } from 'vuex';

export default {
	props: {
		visible: Boolean,
		conferenceTemplateId: [String, Number],
		duration: Number,
		initTime: [String, Number],
		token: String,
		scene: {
			type: String,
			default: 'investor' // investor 邀约卡, survey 预约调研
		},
		meetingScene: {
			type: Number,
			default: 2
		}
	},
	components: {
		'van-popup': Popup,
		'van-tabs': Tabs,
		'van-tab': Tab
	},
	data() {
		return {
			showPopup: false,
			loading: false,
			requestLoading: false,
			dateList: [],
			timeList: [],
			activeMonth: 0,
			activeDay: '',
			selectedTime: 0
		};
	},
	computed: {
		...mapGetters(['getIrThemeColor']),

		activeDateList() {
			return this.dateList[this.activeMonth].children || [];
		},
		endTime() {
			return +this.selectedTime + this.duration * 60000;
		},
		selectedTimeStr() {
			let nowDate = this.$moment(Date.now());
			let startTime = this.$moment(+this.selectedTime);
			let endTime = this.$moment(this.endTime);
			return (
				(startTime.isSame(nowDate, 'day')
					? `${this.$t('今天')} ${startTime.format('HH:mm')}`
					: startTime.isSame(nowDate, 'year')
						? startTime.format(this.$i18n.locale === EN ? 'MMMM D HH:mm' : 'M月D日 HH:mm')
						: startTime.format(this.$i18n.locale === EN ? 'MMMM D YYYY HH:mm' : 'YYYY年M月D日 HH:mm')) +
				' - ' +
				endTime.format('HH:mm')
			);
		}
	},
	watch: {
		visible: {
			handler(newVal) {
				this.showPopup = newVal;
				if (this.showPopup) {
					let currentTime;
					if (this.initTime) {
						this.selectedTime = this.initTime;
						currentTime = this.$moment(this.initTime).startOf('day').valueOf();
					}
					this.getOptionalTime(currentTime);
				}
			},
			immediate: true
		}
	},
	methods: {
		unlockTime() {
			return new Promise(resolve => {
				this.$axios
					.post(appointment.unlockTime(this.conferenceTemplateId), {
						token: this.token,
						showLoading: false
					})
					.then(res => {
						resolve(res);
					});
			});
		},
		getOptionalTime(currentTime) {
			this.loading = true;

			const sceneApiMap = {
				'investor': appointment.getOptionalTime,
				'survey': irstore.getOptionalTime
			};
			const actionOptionalTimeApi = sceneApiMap[this.scene];

			let params = {
				duration: this.duration,
				meetingScene: this.meetingScene
			};
			if (currentTime) {
				params.currentTime = currentTime;
			}
			this.$axios
				.post(actionOptionalTimeApi(this.conferenceTemplateId), params, {
					headers: {
						showLoading: false
					}
				})
				.then(({ data }) => {
					if (data) {
						const { optionalDate, selectedDate, surveyDateList } = data;

						let nowDate = this.$moment(Date.now());
						this.dateList = [];
						optionalDate.sort((a, b) => a - b);
						for (let time of optionalDate) {
							let date = this.$moment(time);
							let month = date.format('YYYY.MM');
							let monthLabel = date.isSame(nowDate, 'year')
								? date.format(this.$i18n.locale === EN ? 'MMMM' : 'M月')
								: date.format(this.$i18n.locale === EN ? 'MMMM YYYY' : 'YYYY年M月');
							let day = date.isSame(nowDate, 'day')
								? this.$t('今天')
								: date.format(this.$i18n.locale === EN ? 'D' : 'D日');

							let item = this.dateList.find(item => item.month == month);
							if (!item) {
								this.dateList.push({
									month,
									label: monthLabel,
									value: time,
									children: [
										{
											label: day,
											value: time
										}
									]
								});
							} else {
								item.children.push({
									label: day,
									value: time
								});
							}
						}

						this.activeDay = selectedDate;
						let index = this.dateList.findIndex(
							date => date.month == this.$moment(+this.activeDay).format('YYYY.MM')
						);
						this.activeMonth = index == -1 ? 0 : index;

						this.timeList = surveyDateList;
						let firstOptional = this.timeList.find(item => item.isOptional);
						let hitOptional = this.timeList.find(item => item.isOptional && item.time == this.initTime);
						if (!this.selectedTime || !hitOptional) {
							this.selectedTime = firstOptional?.time || 0;
							if (!hitOptional) {
								this.$emit('confirm', { time: 0, timeStr: '' });
							}
						}
						setTimeout(() => {
							// 短时间内容只能有一个smooth效果，不然要等上一个滑动结束，才可以接着滑动下一个
							document.querySelector(`#date-${this.activeDay}`)?.scrollIntoView({
								block: 'start'
							});
							document.querySelector(`#time-${firstOptional?.time}`)?.scrollIntoView({
								behavior: 'smooth',
								block: 'start'
							});
						}, 0);
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		changeTab(tab) {
			let startTime = this.dateList[tab].value;
			this.getOptionalTime(startTime);
		},
		selectTime(item) {
			if (!item.isOptional) {
				return;
			}

			this.selectedTime = item.time;
		},
		async confirm() {
			if (!this.selectedTime || this.requestLoading) {
				return;
			}

			// 预约调研不需要锁时间
			if (this.scene === 'survey') {
				this.$emit('confirm', {
					time: this.selectedTime,
					timeStr: this.selectedTimeStr,
					endTime: this.endTime
				});
				this.closePopup();
				return;
			}

			this.requestLoading = true;

			this.unlockTime().then(res => {
				this.$emit('confirm', { time: 0, timeStr: '' });

				this.$axios
					.post(
						appointment.lockTime(this.conferenceTemplateId),
						{
							startTime: this.selectedTime,
							endTime: this.endTime
						},
						{
							headers: {
								showLoading: false
							}
						}
					)
					.then(res => {
						this.requestLoading = false;
						if (+res.code === 0) {
							this.$emit('confirm', {
								time: this.selectedTime,
								timeStr: this.selectedTimeStr,
								endTime: this.endTime
							});
							this.closePopup();
						} else {
							this.selectedTime = 0;
							this.getOptionalTime(this.activeDay);
						}
					})
					.catch(() => {
						this.requestLoading = false;
						this.selectedTime = 0;
						this.getOptionalTime(this.activeDay);
					});
			});
		},
		closePopup() {
			if (this.requestLoading) {
				return;
			}

			this.$emit('update:visible', false);
			this.activeMonth = 0;
			this.selectedTime = 0;
		}
	}
};
</script>

<style lang="less" scoped>
@import '../style/mixin/mixins.less';
@import '../style/mixin/border-radius.less';

.loading-calender,
.empty-calendar {
	height: 3.215rem;
}
.loading-calender,
.request-loading {
	display: flex;
	align-items: center;
	justify-content: center;

	.loading-text {
		margin-top: 0.1rem;

		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.14rem;
		font-weight: 400;
	}
}
.appointment-calendar-popup {
	.header {
		padding: 0.16rem 0.14rem;
		padding-bottom: 0.08rem;

		display: flex;
		align-items: center;
		justify-content: space-between;

		font-family: PingFang SC;
		font-size: 0.15rem;
		font-weight: 500;
		line-height: 0.225rem;
		color: #333333;

		.confirm-button {
			font-weight: 400;
			color: #c5c5c5;

			&.enable-btn {
				color: var(--ir-theme-color);
			}
		}
	}

	.main {
		position: relative;
	}
	.request-loading {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 99;

		background: rgba(255, 255, 255, 0.95);
	}

	.months {
		height: 0.55rem;
		padding: 0 0.275rem;
		.thinner-border-bottom(#E8EAEF);

		/deep/ .van-tabs {
			height: calc(100% - 1px);

			.van-tabs__wrap {
				height: 100%;

				.van-tabs__nav {
					padding: 0;
				}

				.van-tab {
					padding: 0;
					flex: 0;
					overflow: visible;

					font-family: PingFang SC;
					font-size: 0.15rem;
					font-weight: 500;
					line-height: 0.225rem;
					color: #333333;

					&--active {
						color: var(--ir-theme-color);
					}
				}
				.van-tab + .van-tab {
					margin-left: 0.4rem;
				}

				.van-tab__text {
					white-space: nowrap;
				}

				.van-tabs__line {
					bottom: 0;
				}
			}
		}
	}

	.date-time {
		height: 2.2rem;

		display: flex;

		.date-container {
			width: 0.8rem;
			height: 100%;
			box-shadow: 2px 0px 6.5px 0px #0000000a;

			overflow: auto;

			.date-item {
				padding: 0.12rem 0;

				font-family: PingFang SC;
				font-size: 0.15rem;
				font-weight: 400;
				line-height: 0.2rem;
				text-align: center;
				color: #333333;

				&-active {
					font-weight: 500;
					color: var(--ir-theme-color);
				}
			}
		}

		.time-container {
			flex: 1;
			height: 100%;
			padding: 0.12rem 0.1rem;

			overflow: auto;

			display: grid;
			justify-content: space-between;
			grid-template-columns: repeat(4, 0.57rem);
			grid-auto-rows: 0.28rem;
			grid-row-gap: 0.16rem;

			.time-item {
				height: 0.28rem;

				font-family: PingFang SC;
				font-size: 0.15rem;
				font-weight: 400;
				line-height: 0.28rem;
				text-align: center;
				color: #333333;

				&-disabled {
					color: #c5c5c5;
				}

				&-active {
					border-radius: 0.4rem;
					background-color: var(--ir-theme-color);

					font-weight: 500;
					color: #ffffff;
				}
			}
		}
	}
}
</style>
